import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { getRequestCallbackDetails, getUTMParamsFromLogs } from "../../pages/future-orders/helper";
import PropTypes from "prop-types";

const UTMParamsTableModal = ({ setShow, utmParams }) => {

    useEffect(() => {
        const handleEscapeKey = (e) => {
            if (e.key === 'Escape') {
                setShow(false);
            }
        };

        document.addEventListener('keydown', handleEscapeKey);

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [setShow]);

    return (
        <div
            style={{ width: '100vw' }}
            className="flex flex-col justify-center fixed top-0 left-0 bg-black/50 z-50 h-[100vh] w-[100vw]"
        >
            <div className="flex flex-col gap-4 justify-center p-6 rounded-md" style={{ backgroundColor: "white", width: "40vw", marginLeft: "32vw" }}>
                <div className="flex flex-row justify-between">
                    <h1 className="text-2xl font-bold">UTM Parameters</h1>
                    <button className="text-black px-4 py-2 rounded-md" onClick={() => setShow(false)}><FontAwesomeIcon icon={faXmark} /></button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th><span className="mx-5">Source</span></th>
                            <th><span className="mx-5">Medium</span></th>
                            <th><span className="mx-5">Campaign</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {utmParams.map((utmParam) => (
                            <tr key={utmParam.source + utmParam.medium + utmParam.campaign} >
                                <td className="max-w-[100px] overflow-scroll" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                                    <span className="mx-5" >{utmParam.source}</span>
                                </td>
                                <td className="max-w-[100px] overflow-scroll" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                                    <span className="mx-5" >{utmParam.medium}</span>
                                </td>
                                <td className="max-w-[100px] overflow-scroll" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                                    <span className="mx-5" >{utmParam.campaign}</span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}


const UTMParamsModal = ({ original, type }) => {
    const [show, setShow] = useState(false);
    const [logsUTMParams, setLogsUTMParams] = useState([]);

    useEffect(() => {
        (async () => {
            if (original.id && show) {
                const requestCallbackDetails = await getRequestCallbackDetails(original.id);
                const sortedLogs = requestCallbackDetails?.logs?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                if (sortedLogs) {
                    const utmParams = await getUTMParamsFromLogs(sortedLogs);
                    setLogsUTMParams(utmParams);
                }
            }
        })();
    }, [original.id, show]);

    return (
        <div
            className="max-w-[150px] overflow-scroll"
            style={{
                scrollbarWidth: 'none',
                msOverflowStyle: 'none'
            }}
        >
            <span className="cursor-pointer" onClick={() => setShow(true)}>
                {logsUTMParams[0]?.[type] || original?.[type] || "N/A"}
            </span>
            {show && (
                <UTMParamsTableModal
                    setShow={setShow}
                    utmParams={logsUTMParams}
                />
            )}
        </div>
    );
};

export default UTMParamsModal;

UTMParamsModal.propTypes = {
    original: PropTypes.object,
    type: PropTypes.string
};

UTMParamsTableModal.propTypes = {
    setShow: PropTypes.func,
    utmParams: PropTypes.array
};